export default __webpack_public_path__ + "static/Montserrat-Regular-c430087a706cf2a89f21bc72c4abd745.woff2";